import style from './map.module.scss';
import React, {useRef, useState} from "react";
import {OverlayView} from "@react-google-maps/api";
import {clearMap, searchMap} from "../../util/assets";
import {
    findingNearPointMap,
    setActiveMapData,
    setCurrentItem,
    setCurrentItemLoaderLogs,
    setGeoMap,
    sortByCentreSearchMap
} from "../../action/page";
import {getLogs} from "../../thunk/device";
import {getAddressMap} from "../../thunk/map";
import {connect} from "react-redux";
import {setCurrentAlert} from "../../action/alert";

import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import TsunamiIcon from '@mui/icons-material/Tsunami';
import FloodIcon from '@mui/icons-material/Flood';
import CycloneIcon from '@mui/icons-material/Cyclone';
import VolcanoIcon from '@mui/icons-material/Volcano';
import AirIcon from '@mui/icons-material/Air';
import WhatshotIcon from '@mui/icons-material/Whatshot';

function InfoWindowGdacsMapGdacs({
                           page,
                           sortByCentreSearchMap,
                           setCurrentItem,
                           getLogs,
                           getAddressMap,
                           setCurrentAlert,
                           findingNearPointMap
                       }) {
    // const handlerChangeStatus = (id, coord, active) => {
    //     sortByCentreSearchMap({centre: coord});
    //     setCurrentItem({id: id, active, status: "clickByTarget"});
    //     // findingNearPointMap();
    // }
    const handlerChangeStatus = (index) => {
        setActiveMapData({index});
        setCurrentItem(page.data[index]?{...page.data[index], active: true}:{});
        // getLogs({id: page.data[index]._id});
        // setCurrentAlert({id: page.data[index]._id});
        // getAddressMap(page.data[index].geometry.coordinates.join(", "));
    }
    return (
        <>
            {page?.data?.map(
                ({geometry, properties, alertLevel, type}, index) => geometry && geometry && (
                    <OverlayView key={`${index}_location`}
                                 position={{lat: geometry.coordinates[1], lng: geometry.coordinates[0]}}
                                 options={{closeBoxURL: ``, enableEventPropagation: true}}
                                //  zIndex={active ? 15 : ""}
                                 mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}


                    >
                        <div
                            onClick={() => {
                                handlerChangeStatus(index)
                                // handlerChangeStatus(index)
                            }}
                            className={[style.markerRow, style.gdacs, style[`${alertLevel ? alertLevel : 'Nan'}`], style[alertLevel]].join(" ")}
                        >
                            {type === "EQ" && <MonitorHeartIcon className={style.alertIcon}/> || ""}
                            {type === "TS" && <TsunamiIcon className={style.alertIcon}/> || ""}
                            {type === "FL" && <FloodIcon className={style.alertIcon}/> || ""}
                            {type === "TC" && <CycloneIcon className={style.alertIcon}/> || ""}
                            {type === "VO" && <VolcanoIcon className={style.alertIcon}/> || ""}
                            {type === "DR" && <AirIcon className={style.alertIcon}/> || ""}
                            {type === "WF" && <WhatshotIcon className={style.alertIcon}/> || ""}
                            
                            <div className={style.markerItem}>
                                
                                {properties.severitydata.severity ? Math.round(properties.severitydata.severity) : ""}
                            </div>
                        </div>
                    </OverlayView>
                )
            ) || ""}
        </>
    )
}

const mapStateToProps = state => ({
    page: state.page,
});

const mapDispatchToProps = dispatch => ({
    // login: data => dispatch(login(data))
    setActiveMapData: data => dispatch(setActiveMapData(data)),
    setCurrentItem: data => dispatch(setCurrentItem(data)),
    getLogs: data => dispatch(getLogs(data)),
    getAddressMap: data => dispatch(getAddressMap(data)),
    setCurrentAlert: data => dispatch(setCurrentAlert(data)),
    findingNearPointMap: data => dispatch(findingNearPointMap(data)),
    sortByCentreSearchMap: data => dispatch(sortByCentreSearchMap(data)),
    setCurrentItemLogs: data => dispatch(setCurrentItemLoaderLogs(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InfoWindowGdacsMapGdacs);